import { useContext } from "react";

import { WizardContext } from "./wizard-provider";

export const useWizardContext = () => {
  const context = useContext(WizardContext);

  if (!context) {
    throw new Error("useWizardContext can only be used inside WizardProvider");
  }

  return context;
};
